import React, { useState, useEffect } from "react";
import buildingImg from "../../assets/images/building_burz.png";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { baseUrl } from "../../config/baseUrl";
import { DaySelector } from "../edu-helper/day-selector";
import { toast, Bounce } from "react-toastify";

export default function CampusEdit({
  selectCampusRow,
  setForceUpdate,
  forceUpdate,
}) {
  let navigate = useNavigate();
  let loginUser = JSON.parse(localStorage.getItem("user"));

  const { campus_description, campus_name, company, days, id } =
    selectCampusRow;
  const [campusDescription, setCampusDescription] = useState(
    Boolean(campus_description) ? campus_description : ""
  );
  const [campusName, setCampusName] = useState(campus_name);
  const [companyModal, setCompanyModal] = useState(company);
  const [daysModal, setDaysModal] = useState(days);
  const [idModal, setIdModal] = useState(id);

  useEffect(() => {
    setCampusDescription(Boolean(campus_description) ? campus_description : "");
    setCampusName(campus_name);
    setCompanyModal(company);
    setDaysModal(days);
    setIdModal(id);
  }, [campus_description, campus_name, company, days, id]);

  const areArraysEqual = (arr1, arr2) => {
    if (arr1.length !== arr2.length) return false;
    return arr1.every((item, index) => item === arr2[index]);
  };

  const getChangedFields = () => {
    return {
      ...(campusDescription !== campus_description
        ? { campus_description: campusDescription }
        : {}),
      ...(campusName !== campus_name ? { campus_name: campusName } : {}),
      ...(company !== companyModal ? { company: companyModal } : {}),
      //   ...(!areArraysEqual(days, daysModal) ? { days: daysModal } : {}), // Proper array comparison
      ...(id !== idModal ? { id: id } : {}),
    };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const patchData = getChangedFields();
    let response;
    try {
      response = await axios(`${baseUrl}/udpate_campus/${id}/`, {
        method: "PATCH",
        headers: {
          Authorization: "Token " + localStorage.getItem("token"),
        },
        data: { ...patchData },
      });

      if (response?.status === 200) {
        let unique = document.getElementById("close3");
        unique.click();
        setForceUpdate(!forceUpdate);
        toast.success("Edit College Successfully", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      }
    } catch (error) {
      toast.error(error.response.data.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    }
  };

  return (
    <>
      <div
        className="modal fade custom-modal addcampus-modal"
        id="editcampus"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content">
            <div className="modal-header justify-content-center">
              <h5 className="modal-title" id="">
                Edit College
              </h5>
              <button
                type="button"
                className="modal-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="close3"
              >
                <i className="fa fa-times" />
              </button>
            </div>
            <div className="modal-body">
              <div className="d-flex flex-row justify-content-center align-items-center">
                <div className="col-lg-5 text-center">
                  <div className="addbus-modal-innr">
                    <img src={buildingImg} alt="" width="316" height="316" />
                    <form action="" onSubmit={handleSubmit}>
                      <div className="row justify-content-center">
                        <div className="frm-bx mb-4 col-lg-8 mb-3 text-start">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Campus Name"
                            name="campus_name"
                            onChange={(e) => {
                              setCampusName(e.target.value);
                            }}
                            value={campusName}
                          />
                          <span className="fa fa-solid fa-tent icon" />
                        </div>
                        <div className="frm-bx mb-4 col-lg-8 mb-3 text-start">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter college address"
                            name="campus_desc"
                            onChange={(e) => {
                              setCampusDescription(e.target.value);
                            }}
                            value={campusDescription}
                          />
                          <span className="fa fa-solid fa-tent-arrows-downicon" />
                        </div>
                        <div className="frm-bx mb-4 col-lg-8 mb-3">
                          <button className="thm-btn" type="submit">
                            Submit
                          </button>
                        </div>
                        {/* <div>
                          <DaySelector
                            initialSelectedDays={daysModal}
                            onDaysChange={setDaysModal}
                          />
                        </div> */}
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              {/* <div className="row justify-content-center align-items-center">
                <div className="col-lg-5 text-center">
                  <div className="addbus-modal-innr">
                    <img src={buildingImg} alt="" />
                    <form action="" onSubmit={handleSubmit}>
                      <div className="row justify-content-center">
                        <div className="frm-bx mb-4 col-lg-8 mb-3 text-start">
                          <select
                            name="company"
                            onChange={ChangeHandler}
                            className="form-select"
                            defaultValue={editVal?.company_name}
                          >
                            {companyNameData.map((arr) => {
                              return (
                                <option key={arr?.id} value={arr?.id}>
                                 {editVal?.company_name}
                                </option>
                              );
                            })}
                          </select>
                          <span className="fa fa-building icon" />
                        </div>
                        <div className="frm-bx mb-4 col-lg-8 mb-3 text-start">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Bus Number"
                            name="bus_number"
                            onChange={ChangeHandler}
                            value={editVal?.bus_number}
                          />
                          <span className="fa fa-server icon" />
                        </div>
                        <div className="frm-bx mb-4 col-lg-8 mb-3 text-start">
                          <select
                            name="depo"
                            onChange={ChangeHandler}
                            className="form-select"
                            // value={editVal?.depo_name}
                          >
                            <option >Select Depot Name</option>
                            {depoData.map((arr) => {
                              return (
                                <option key={arr?.id} value={arr?.id}  selected={editVal?.depo_name === arr.depo_name && true}>
                                  {arr.depo_name}
                                </option>
                                
                              );
                            })}
                               
                          </select>
                          <span className="fa fa-server icon" />
                        </div>
                       
                        <div className="frm-bx mb-4 col-lg-8 mb-3">
                          <button className="thm-btn" type="submit">
                          Submit
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
